<h2 class="pb-[2.5rem]">{{ 'mobilityRef.title' | transloco }}</h2>
@if(loading()) {
<div class="my-[6.25rem]"><loader /></div>
} @else if (filters().length > 0) {
<p class="mb-[2.5rem]">{{ 'mobilityRef.description' | transloco }}</p>
<div class="flex flex-col items-end gap-[2.5rem]">
  <div class="flex flex-col gap-10 w-full">
    <app-filter-section
      [filterType]="activitiesFilters().filterSetType"
      [filtersSelectedInput]="activitiesFiltersSelected()"
      [name]="activitiesFilters().localName"
      [filter]="activitiesFilters()"
      (isEmpty)="onActivitiesEmpty($event)"
      (updateFiltersSelected)="updateFiltersSelected($event)"
    ></app-filter-section>
    <app-filter-section
      [filterType]="localisationFilters().filterSetType"
      [filtersSelectedInput]="locationFiltersSelected()"
      [name]="localisationFilters().localName"
      [filter]="localisationFilters()"
      (isEmpty)="onLocalisationsEmpty($event)"
      (updateFiltersSelected)="updateFiltersSelected($event)"
    ></app-filter-section>
  </div>
  <div
    class="flex flex-col sm:flex-row gap-[1.5rem] items-end sm:items-center mb-[2.5rem]"
  >
    @if(isFiltersEmpty()) {
    <p>{{ 'mobilityRef.filterSelectionRule' | transloco }}</p>
    }

    <div
      class="flex flex-col sm:flex-row sm:gap-[1.5rem] items-end sm:items-center gap-[1rem]"
    >
      <app-button
        [text]="'components.filterButton.saveSearch' | transloco"
        [icon]="isFavoriteSearchSuccessSaved() ? 'thumb-up-filled' : 'thumb-up'"
        [variant]="isFiltersEmpty() ? 'secondary' :'primary'"
        [disabled]="isFiltersEmpty() || isFavoriteSearchSuccessSaved()"
        (buttonClick)="openAddFavoriteModal()"
      ></app-button>

      <app-button
        [text]="'mobilityRef.submitButtonText' | transloco"
        [icon]="'arrow-right'"
        [variant]="'secondary'"
        [disabled]="isFiltersEmpty()"
        (buttonClick)="startResearch()"
      ></app-button>
    </div>
  </div>
</div>
@if (isAddToFavoriteModalOpen()) {
<app-input-modal
  [title]="'components.addFavoriteFilterModal.Title' | transloco"
  [text]="'components.addFavoriteFilterModal.Text' | transloco"
  [inputTitle]="'components.addFavoriteFilterModal.PersonnalizedLabel' | transloco"
  [buttonText]="'components.addFavoriteFilterModal.CtaText' | transloco"
  [placeholder]="'components.addFavoriteFilterModal.PlaceholderText' | transloco"
  (completeModal)="saveSearch($event)"
  (closeModal)="closeAddFavoriteModal()"
></app-input-modal>
} }

<app-favorite-search-error-modal />